import React, { useEffect, useState } from "react";
import BaseButton from "Components/Base/BaseButton";
import BaseInput from "Components/Base/BaseInput";
import { BaseSelect } from "Components/Base/BaseSelect";
import {
  InputPlaceHolder,
  SelectPlaceHolder,
  validationMessages,
} from "Components/constants/validation";
import { useFormik } from "formik";
import { submitLabel } from "Components/constants/Role";
import { RepairOrderReopenLabel } from "Components/constants/RepairOrderReopen";
import { checkStatusCodeSuccess } from "Components/constants/Common";
import { listofCloseRO, reopenRO } from "Api/RepairOrderReopen";
import { toast } from "react-toastify";
import * as yup from "yup";
import {
  DATE_LABEL,
  REASON_FOR_REOPEN_LABEL,
  RO_NO_LABEL,
} from "Components/constants/ROModule";

const RepairOrdReopen = () => {
  const [RONumberList, setRONumberList] = useState<any[]>([]);
  const [selectedRONo, setSelectedRONo] = useState<string | null>(null);
  const [btnLoader, setBtnLoader] = useState(false);

  const validationSchema = yup.object({
    SelectRONo: yup.string().required(validationMessages.required(RO_NO_LABEL)),
    Date: yup.date().required(validationMessages.required(DATE_LABEL)),
    Reason_For_Reopen: yup
      .string()
      .required(validationMessages.required(REASON_FOR_REOPEN_LABEL)),
  });

  const formik = useFormik({
    initialValues: {
      SelectRONo: "",
      Date: new Date().toISOString().split("T")[0],
      Reason_For_Reopen: "",
    },
    validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = (values: any) => {
    const payload = {
      repair_order_id: selectedRONo,
      close_date: values.Date,
      reopen_reason: values.Reason_For_Reopen,
    };

    setBtnLoader(true);
    reopenRO(payload)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          toast.success(res.message);
          formik.resetForm();
        } else {
          toast.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      })
      .finally(() => {
        setBtnLoader(false);
      });
  };

  const fetchRONOOptions = () => {
    listofCloseRO()
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          const data = res?.data;
          setRONumberList(
            data.map((item: any) => ({
              values: item?.id,
              label: item.ro_no,
              value: item.id,
            }))
          );
        } else {
          console.error(res.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || err?.message);
      });
  };

  useEffect(() => {
    fetchRONOOptions();
  }, []);

  document.title = RepairOrderReopenLabel;

  return (
    <div className="page-content">
      <div className="flex-grow-1 mx-3">
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
            <span className="fs-4 d-flex gap-4">{RepairOrderReopenLabel}</span>
          </div>

          <div className="card py-2 px-4 overflow-x-auto">
            <div className="d-flex flex-wrap justify-content-between mb-1 pe-auto w-100"></div>

            <div className="d-flex flex-wrap mb-1 pe-auto">
              <div className="col mb-0 me-4">
                <BaseSelect
                  name="SelectRONo"
                  label={RO_NO_LABEL}
                  options={RONumberList}
                  value={formik.values.SelectRONo}
                  handleChange={(name: any, value: any) => {
                    formik.setFieldValue(name, value);
                    setSelectedRONo(value === "" ? null : value);
                  }}
                  required
                  handleBlur={formik.handleBlur}
                  error={formik.errors.SelectRONo}
                  touched={formik.touched.SelectRONo}
                />
              </div>
              <div className="col mb-0 me-4">
                <BaseInput
                  name="Date"
                  label={DATE_LABEL}
                  placeholder={SelectPlaceHolder("")}
                  value={formik.values.Date}
                  onChange={formik.handleChange}
                  handleBlur={formik.handleBlur}
                  error={formik.errors.Date}
                  touched={formik.touched.Date}
                  type="date"
                  required
                />
              </div>
              <div className="col mb-0">
                <BaseInput
                  type="textarea"
                  name="Reason_For_Reopen"
                  label={REASON_FOR_REOPEN_LABEL}
                  placeholder={InputPlaceHolder(REASON_FOR_REOPEN_LABEL)}
                  value={formik.values.Reason_For_Reopen}
                  onChange={formik.handleChange}
                  handleBlur={formik.handleBlur}
                  error={formik.errors.Reason_For_Reopen}
                  touched={formik.touched.Reason_For_Reopen}
                  required
                />
              </div>
            </div>

            <div className="d-flex justify-content-end mb-1 mt-4 w-100 mb-4">
              <div className="col-12 d-flex justify-content-end mb-0 mb-4">
                <BaseButton
                  type="submit"
                  label={submitLabel}
                  color="success"
                  loader={btnLoader}
                  disable={btnLoader}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RepairOrdReopen;
